import { useSelector } from '@xstate/react';
import { ActorRefFrom } from 'xstate';
import { WizardSteps } from '../constants';
import { peerRefMachine } from '../peerReferenceMachine';
interface WizardProps {
  actor: ActorRefFrom<typeof peerRefMachine>;
}

export const PeerRefWizard = (props: WizardProps) => {
  const { actor } = props;
  const { step } = useSelector(actor, (state) => state.context);

  const wizardPage = WizardSteps[step];

  return (
    <div className="rounded-xl border border-grey-900 bg-white p-6 shadow-sm sm:p-8">
      <wizardPage.component actor={actor} />
    </div>
  );
};
